const Russian = () => {
	return (
		<svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clip-path='url(#clip0_11584_3014)'>
				<path d='M0 16C0 7.1635 7.1635 0 16 0C24.8365 0 32 7.1635 32 16' fill='#338AF3' />
				<path
					d='M31.0859 21.3335C28.8892 27.5473 22.9661 32.0002 16 32.0002C9.03393 32.0002 3.11085 27.5473 0.914062 21.3335H31.0859Z'
					fill='#E42F2F'
				/>
				<path
					d='M31.0859 10.6665C31.6758 12.335 32 14.1294 32 15.9998C32 17.8703 31.6758 19.6647 31.0859 21.3332H0.914063C0.324197 19.6647 0 17.8703 0 15.9998C0 14.1294 0.324198 12.335 0.914063 10.6665H31.0859Z'
					fill='#3677E7'
				/>
				<path
					d='M16 0C22.9661 0 28.8892 4.4529 31.0859 10.6667H0.914062C3.11085 4.4529 9.03393 0 16 0Z'
					fill='#F4F4F4'
				/>
			</g>
			<defs>
				<clipPath id='clip0_11584_3014'>
					<rect width='32' height='32' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export default Russian;
